/**
 * Render text with search matches wrapped in <mark>. Pure React — never builds HTML strings, so
 * user-written text (event notes, topics) can't inject markup, and the query is regex-escaped.
 */
export default function Highlight({ text, query }: { text?: string | null; query?: string }) {
  if (!text) return null
  const q = (query ?? '').trim()
  if (!q) return <>{text}</>
  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const parts = text.split(new RegExp(`(${escaped})`, 'gi'))
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === q.toLowerCase()
          ? <mark key={i} className="bg-yellow-200 px-0.5 rounded">{part}</mark>
          : <span key={i}>{part}</span>
      )}
    </>
  )
}
